<template>
    <div class="container-fluid">
        <h1>{{ title }}</h1>
        <br />
        <span class="badge badge-primary" v-show="loading">{{
            $t('loading')
        }}</span>
        <b-form
            ref="webthemeform"
            class="col-xs-8 col-md-8 pb-5"
            v-if="!loading"
            name="webThemeForm"
            v-on:submit.prevent="$_onSubmit"
        >
            <!-- Generated Url-->
            <b-row v-if="inEditMode">
                <b-col cols="8">
                    {{ $t('generatedUrl') }}
                    <b-link :href="shortUrl" target="_blank">{{
                        this.shortUrl
                    }}</b-link>
                </b-col>
                <b-col>
                    <x-checkbox
                        name="chkUseGuid"
                        :text="$t('labelUseGuid')"
                        v-model="webtheme.useGuid"
                    >
                    </x-checkbox>
                    <p class="warning" v-if="dbUseGuid != webtheme.useGuid">
                        {{ $t('warningChangedWebThemeUrl') }}
                    </p>
                </b-col>
            </b-row>
            <div v-else>
                {{ $t('webThemeCardAddNewWebtheme') }}
            </div>
            <br />
            <!-- Name -->
            <div>
                <x-input
                    :id="`webthemeName`"
                    :name="`webthemeName`"
                    :text="$t('columnNameName')"
                    maxlength="50"
                    :state="!errorInUse"
                    :invalidMessage="nameErrorMessage"
                    v-model="webtheme.name"
                    @input="$_exists"
                    required
                    autofocus
                >
                </x-input>
            </div>
            <!-- Alias -->
            <div>
                <x-input
                    :id="`webthemeAlias`"
                    :name="`webthemeAlias`"
                    :text="'Alias'"
                    maxlength="50"
                    v-model="webtheme.alias"
                    :state="$_validateAlias()"
                    :invalidMessage="aliasErrorMessage"
                    required
                >
                </x-input>
            </div>
            <!-- Description -->
            <div class="form-group">
                <x-textarea
                    :id="`txtDescription`"
                    :name="`txtDescription`"
                    :text="$t('description')"
                    :rows="3"
                    :maxlength="2000"
                    v-model="webtheme.description"
                    required
                >
                </x-textarea>
            </div>
            <div>
                <x-checkbox
                    :name="'chkWelcomeMessage'"
                    :disabled="$_welcomeMessageEnabled()"
                    v-model="webtheme.showWelcomeMessage"
                    :text="$t('menuItemWelcomeMessage')"
                    class="mb-2"
                >
                </x-checkbox>
                <!-- Welkomsttitel -->
                <x-input
                    :id="`txtWelcomeMessageTitle`"
                    :name="`txtWelcomeMessageTitle`"
                    :text="$t('columnNameTitle')"
                    maxlength="100"
                    :value="welcomeMessageTitle"
                    :class="
                        !webtheme.showWelcomeMessage ? 'no-welcome-panel' : ''
                    "
                    @input="$_textWelcomeMessageTitle"
                    :required="webtheme.showWelcomeMessage"
                >
                </x-input>
                <!-- Welkomstbericht -->
                <label
                    :class="
                        !webtheme.showWelcomeMessage ? 'no-welcome-panel' : ''
                    "
                >
                    {{ $t('columnNameMessage') }}
                </label>
                <VueEditor
                    class="mb-3"
                    :id="`txtWelcomeMessage`"
                    :name="`txtWelcomeMessage`"
                    maxlength="1000"
                    v-model="webtheme.welcomeMessage"
                    :class="
                        !webtheme.showWelcomeMessage ? 'no-welcome-panel' : ''
                    "
                    :editorToolbar="customToolbar"
                    :required="webtheme.showWelcomeMessage"
                >
                </VueEditor>
            </div>
            <!-- web-feedback enable -->
            <b-form-group>
                <b-form-radio
                    class="inline mr-3"
                    v-model="themeType"
                    name="enable-web-theme"
                    :value="'web-theme'"
                    @change="$_onClickEnableWebTheme"
                    >{{ $t('themeCard') }}</b-form-radio
                >
                <b-form-radio
                    class="inline"
                    v-model="themeType"
                    name="enable-web-feedback"
                    :value="'web-feedback-theme'"
                >
                    {{ $t('notificationCard') }}
                </b-form-radio>
            </b-form-group>
            <div v-if="themeType === 'web-feedback-theme'">
                <!-- Show Feedback Join button -->
                <x-checkbox
                    name="chkshowfeedbackjoin"
                    :text="$t('labelShowJoinFeedback')"
                    v-model="webtheme.showJoinFeedbackButton"
                >
                </x-checkbox>
                <!-- Show Feedback Different button -->
                <x-checkbox
                    name="chkshowfeedbackdifferent"
                    :text="$t('labelShowDifferentFeedback')"
                    v-model="webtheme.showDifferentFeedbackButton"
                >
                </x-checkbox>
                <br />
            </div>
            <div class="form-group">
                <x-input
                    :text="$t('labelMunicipalitiesWebTheme')"
                    :placeholder="$t('labelMunicipalitiesExample')"
                    v-model="webtheme.locations"
                    :id="'plaatsen'"
                    :name="'plaatsen'"
                    maxlength="200"
                >
                </x-input>
            </div>
            <!-- Theme selection list -->
            <div class="form-group">
                <!-- Couple the theme based on its id -->
                <x-select
                    :id="`slcTheme`"
                    :name="`slcTheme`"
                    :text="$_getThemeLableText()"
                    @selected="$_onSelectThemeId"
                    :options="computedThemes"
                    :value="selectedThemeId"
                    :required="isWebTheme"
                    :simpleMode="true"
                >
                </x-select>
                <!-- Storage layer selection list -->
                <div
                    v-if="themeType === 'web-feedback-theme'"
                    class="form-group"
                >
                    <!-- Couple the feedback based on its id-->
                    <x-select
                        :id="`slcFeedback`"
                        :name="`slcFeedback`"
                        :text="$t('feedback')"
                        @selected="$_onSelectFeedbackTypeId"
                        :options="computedFeedbackthemes"
                        :value="selectedFeedbackTypeId"
                        :required="themeType === 'web-feedback-theme'"
                        :simpleMode="true"
                    >
                    </x-select>
                </div>
                <!-- Storage layer(Measurement) selection list -->
                <div v-if="isWebTheme">
                    <x-select
                        :id="`slcMeasurement`"
                        :name="`slcMeasurement`"
                        :text="`${$t('labelMeasure')}${$t('labelOptional')}`"
                        @selected="$_onSelectMeasurementTypeId"
                        :options="computedMeasurements"
                        :value="selectedMeasurementTypeId"
                        :simpleMode="true"
                    >
                    </x-select>
                </div>
                <!-- Logo -->
                <div class="form-group">
                    <BaseSelect
                        :name="'slcWebLogo'"
                        :text="`${$t('labelLogo')}${$t('labelOptional')}`"
                        :value="webtheme.logoId > 0 ? webtheme.logoId : null"
                        :options="$_availableLogos(organizationBitmaps)"
                        @selected="$_onLogoSelected"
                    >
                    </BaseSelect>
                    <b-link
                        :id="`addLogo`"
                        :name="`addLogo`"
                        @click="
                            $_openAddBitmapModal(
                                availableLogoTypeConst[0].value
                            )
                        "
                    >
                        &nbsp;
                        <em class="fa fa-plus"></em>&nbsp;{{
                            $t('imageAddButton', [
                                `${$t('labelLogo').toLowerCase()}`
                            ])
                        }}
                    </b-link>
                </div>
                <!-- Favicon -->
                <div class="form-group">
                    <BaseSelect
                        :name="'slcWebFavicon'"
                        :text="`${$t('labelFavicon')}${$t('labelOptional')}`"
                        :value="
                            webtheme.faviconId > 0 ? webtheme.faviconId : null
                        "
                        :options="$_availableFavicons(organizationBitmaps)"
                        @selected="$_onFaviconSelected"
                    >
                    </BaseSelect>
                    <b-link
                        :id="`addFavicon`"
                        :name="`addFavicon`"
                        @click="
                            $_openAddBitmapModal(
                                availableLogoTypeConst[1].value
                            )
                        "
                    >
                        &nbsp;
                        <em class="fa fa-plus"></em>&nbsp;{{
                            $t('imageAddButton', [
                                `${$t('labelFavicon').toLowerCase()}`
                            ])
                        }}
                    </b-link>
                </div>
                <!-- Portal group -->
                <div class="form-group" v-show="hasPortalLicense">
                    <label for="webtheme-group">{{
                        $t('columnNamePortalGroup')
                    }}</label>
                    <b-form-tags
                        :name="'webtheme-group'"
                        input-id="webtheme-group"
                        v-model="tags"
                        separator=","
                    >
                        <template v-slot="{ tags, disabled, removeTag }">
                            <ul
                                v-if="tags.length > 0"
                                class="list-inline d-inline-block mb-2"
                            >
                                <li
                                    v-for="tag in tags"
                                    :key="tag"
                                    class="list-inline-item"
                                >
                                    <b-form-tag
                                        @remove="removeTag(tag)"
                                        :title="tag"
                                        :disabled="disabled"
                                        >{{ tag }}</b-form-tag
                                    >
                                </li>
                            </ul>
                            <b-input-group>
                                <b-form-input
                                    :placeholder="
                                        $t(
                                            'webThemeEnterPortalGroupInstruction'
                                        )
                                    "
                                    v-model="newTag"
                                    list="list"
                                    @change="savePortalGroupSelection(newTag)"
                                />
                                <b-input-group-append>
                                    <b-button
                                        @click="
                                            savePortalGroupSelection(newTag)
                                        "
                                        variant="primary"
                                        >{{ $t('btnAddLabel') }}</b-button
                                    >
                                </b-input-group-append>
                                <datalist id="list">
                                    <option
                                        v-for="option in webthemePortalGroups"
                                        :key="option.value"
                                        :value="option.value"
                                    />
                                </datalist>
                            </b-input-group>
                        </template>
                    </b-form-tags>
                </div>
                <!-- Portal theme group -->
                <div class="form-group" v-show="hasPortalLicense">
                    <label for="webtheme-portalthemegroup">{{
                        $t('columnNamePortalThemeGroup')
                    }}</label>
                    <b-input-group>
                        <b-form-input
                            :placeholder="
                                $t('webThemeEnterPortalThemeGroupInstruction')
                            "
                            v-model="portalThemeGroup"
                            list="themelist"
                            @change="
                                savePortalThemeGroupSelection(portalThemeGroup)
                            "
                        />
                        <datalist id="themelist">
                            <option
                                v-for="option in webthemePortalThemeGroups"
                                :key="option.value"
                                :value="option.value"
                            />
                        </datalist>
                    </b-input-group>
                </div>
                <!-- Icon for portal -->
                <div v-if="showPortalIcon" class="form-group">
                    <label class="col-form-label">{{ $t('icon') }}</label>
                    <info-button :name="'btn-info'" />
                    <tooltip
                        :target="'btn-info'"
                        :title="$t('uploadImageInfo')"
                        :customClass="'large'"
                    >
                    </tooltip>
                    <br />
                    <image-loader
                        name="webtheme"
                        v-model="webtheme.portalImage"
                    >
                    </image-loader>
                </div>
                <div class="form-group">
                    <label class="col-form-label">{{
                        $t('labelOptions')
                    }}</label>
                    <!-- Options -->
                    <ul style="list-style-type: none">
                        <li>
                            <div>
                                <!-- Show Legend-->
                                <b-form-checkbox
                                    id="chklegenda"
                                    name="chklegenda"
                                    v-model="webtheme.showLegenda"
                                    class="d-inline-block mr-2"
                                >
                                    {{ $t('labelMenuButton') }}
                                </b-form-checkbox>
                                <!-- Legend opened by default-->
                                <b-form-checkbox
                                    id="chklegendaopen"
                                    name="chklegendaopen"
                                    :disabled="
                                        webtheme.openAdvancedSearchByStart
                                    "
                                    v-model="webtheme.openLegenda"
                                    class="d-inline-block"
                                >
                                    {{ $t('labelMenuStandaard') }}
                                </b-form-checkbox>
                            </div>
                        </li>
                        <li>
                            <!-- Show search field -->
                            <x-checkbox
                                name="chksearch"
                                :text="$t('labelSearchField')"
                                v-model="webtheme.showSearch"
                                @input="$_onInputShowSearchField(webtheme)"
                            >
                            </x-checkbox>
                            <!-- Advanced Search standard open option-->
                            <x-checkbox
                                v-if="isWebTheme"
                                name="chkAdvancedSearchOpen"
                                class="ml-4"
                                :disabled="
                                    webtheme.openLegenda || !webtheme.showSearch
                                "
                                :text="$t('labelOpenAdvancedSearchByStart')"
                                v-model="webtheme.openAdvancedSearchByStart"
                            >
                            </x-checkbox>
                            <x-checkbox
                                v-if="isWebTheme"
                                name="chkShowOnlyViewport"
                                class="ml-4"
                                :disabled="!webtheme.showSearch"
                                :text="$t('labelShowOnlyViewport')"
                                v-model="webtheme.showOnlyViewport"
                            >
                            </x-checkbox>
                            <x-checkbox
                                v-if="isWebTheme"
                                name="chkOnlyViewPortDefaultValue"
                                class="ml-4"
                                :disabled="!webtheme.showSearch"
                                :text="$t('labelOnlyViewPortDefaultValue')"
                                v-model="webtheme.onlyViewportDefaultValue"
                            >
                            </x-checkbox>
                        </li>
                        <li>
                            <!-- Show filter button -->
                            <x-checkbox
                                name="chkfilter"
                                :text="$t('labelFilter')"
                                v-model="webtheme.showFilter"
                            >
                            </x-checkbox>
                        </li>
                        <li>
                            <!-- Show zoom in/out buttons-->
                            <x-checkbox
                                name="chkzoom"
                                :text="$t('labelZoomButton')"
                                v-model="webtheme.showZoom"
                            >
                            </x-checkbox>
                        </li>
                        <li>
                            <!-- Show GPS-tracker -->
                            <x-checkbox
                                name="chkgeolocation"
                                :text="$t('labelGPSTracker')"
                                v-model="webtheme.showGPSTracker"
                            >
                            </x-checkbox>
                        </li>
                        <li>
                            <!-- Full screen label-->
                            <x-checkbox
                                name="chkfullscreen"
                                :text="$t('labelFullScreen')"
                                v-model="webtheme.showFullScreen"
                            >
                            </x-checkbox>
                        </li>
                        <li>
                            <!-- Show TableView label -->
                            <x-checkbox
                                v-if="isWebTheme"
                                name="chkshowtableview"
                                :text="$t('labelShowTableView')"
                                v-model="webtheme.showTableView"
                                @input="$_onInputTableView(webtheme)"
                            >
                            </x-checkbox>
                            <!-- Also on small devices option-->
                            <x-checkbox
                                v-if="isWebTheme"
                                class="ml-4"
                                :disabled="!webtheme.showTableView"
                                name="chkShowTableViewSmallDevices"
                                :text="$t('labelShowTableViewSmallDevices')"
                                v-model="webtheme.showTableViewSmallDevices"
                            >
                            </x-checkbox>
                            <!-- Show Export label -->
                            <x-checkbox
                                v-if="isWebTheme"
                                class="ml-4"
                                :disabled="!webtheme.showTableView"
                                name="chkexport"
                                :text="$t('labelExportable')"
                                v-model="webtheme.exportable"
                            >
                            </x-checkbox>
                        </li>
                        <li>
                            <!-- Print option-->
                            <x-checkbox
                                name="chkPrint"
                                :text="$t('labelPrint')"
                                v-model="webtheme.showPrint"
                            >
                            </x-checkbox>
                        </li>
                        <li>
                            <!-- Save Viewport option-->
                            <x-checkbox
                                name="chkSaveViewport"
                                :text="$t('labelSaveViewport')"
                                v-model="webtheme.saveViewport"
                            >
                            </x-checkbox>
                        </li>

                        <li>
                            <!-- Show toolbar -->
                            <x-checkbox
                                name="chkShowToolbar"
                                :text="$t('labelShowToolbar')"
                                v-model="webtheme.showToolbar"
                            >
                            </x-checkbox>
                        </li>
                        <li>
                            <!-- ShowHideAllLayers -->
                            <x-checkbox
                                name="chkShowHideAllLayers"
                                :text="$t('webTheme.labelShowHideAllLayers')"
                                v-model="webtheme.showHideAllLayers"
                            >
                            </x-checkbox>
                        </li>
                        <li v-if="!isWebTheme">
                            <!-- ShowDeleteFeedback -->
                            <x-checkbox
                                name="chkShowDeleteFeedback"
                                :text="$t('webTheme.labelShowDeleteFeedback')"
                                v-model="webtheme.showDeleteFeedback"
                            >
                            </x-checkbox>
                        </li>
                        <li v-if="!isWebTheme">
                            <!-- Show snap -->
                            <x-checkbox
                                name="chkShowSnap"
                                :text="$t('webTheme.labelShowSnap')"
                                v-model="webtheme.showSnap"
                            >
                            </x-checkbox>
                        </li>
                    </ul>
                    <div>
                        <!-- Color of name in toolbar -->
                        <label for="nameColor">
                            {{ $t('labelNameFillColor') }}
                        </label>
                        <div class="form-inline mb-3">
                            <color-picker
                                id="nameFillColor"
                                v-model="webtheme.nameFillColor"
                            >
                            </color-picker>
                        </div>
                    </div>
                    <!-- Highlight organization border -->
                    <div class="form-group">
                        <x-select
                            :id="`slcHighlightBorder`"
                            :name="`slcHighlightBorder`"
                            :text="$t('labelOrganizationPolygon')"
                            :value="selectedHighlightBorder"
                            @selected="
                                $_onSelectHighlightBorder($event, webtheme)
                            "
                            :options="borderHighlightOptions"
                            :simpleMode="true"
                            :required="true"
                        >
                        </x-select>
                    </div>
                    <div>
                        <span class="badge badge-primary" v-show="loading">{{
                            $t('loading')
                        }}</span>
                        <!-- Baselayer select deselect block with ordering -->
                        <div>
                            <DualListBox
                                :titleAvailable="$t('labelSubstrateLayers')"
                                :titleSelected="
                                    $t('labelSubstrateLayersSelected')
                                "
                                :itemsAvailable="computedAvailableBaseLayers"
                                :itemsSelected="computedSelectedBaseLayers"
                                :items="computedBaseLayers"
                                :itemDisplayName="'title'"
                                @update="$_updateComputedBaseLayers($event)"
                            >
                            </DualListBox>
                        </div>
                        <template v-if="showpart">
                            <div class="col-xs-8 col-md-4 pl-0">
                                <div class="form-group">
                                    <x-number
                                        :id="'nmbWidth'"
                                        :name="'nmbWidth'"
                                        :text="$t('labelCardWidth')"
                                        :invalidMessage="widthErrorMessage"
                                        :state="widthErrorState"
                                        v-model="webtheme.parameters.width"
                                        @input="$_validateWidth"
                                        required
                                    >
                                    </x-number>
                                    <x-number
                                        :id="'nmbHeight'"
                                        :name="'nmbHeight'"
                                        :text="$t('labelCardHeight')"
                                        :invalidMessage="heightErrorMessage"
                                        :state="heightErrorState"
                                        v-model="webtheme.parameters.height"
                                        @input="$_validateHeight"
                                        required
                                    >
                                    </x-number>
                                </div>
                            </div>

                            <!-- Web preview -->
                            <div v-if="webtheme.id && webtheme.id > 0">
                                <!-- Scale -->
                                <div class="form-group form-inline">
                                    <label class="col-form-label mr-2">
                                        {{ $t('scaleCurrent') }}
                                    </label>
                                    <div class="scale mr-2">
                                        {{ this.currentScale }}
                                    </div>
                                </div>
                                <div class="form-group form-inline">
                                    <label
                                        for="nmbScale"
                                        class="col-form-label mr-2 scale-label"
                                    >
                                        {{ $t('scaleNew') }}
                                    </label>
                                    <x-number
                                        :id="'nmbScale'"
                                        :name="'nmbScale'"
                                        :minValue="50"
                                        :maxValue="1000000000"
                                        :invalidMessage="scaleErrorMessage"
                                        :required="false"
                                        :state="scaleErrorState"
                                        v-model="newScale"
                                        @input="$_validateScale"
                                        class="mr-2"
                                    >
                                    </x-number>
                                    <b-button
                                        variant="primary"
                                        size="sm"
                                        @click="$_onClickScale"
                                        :disabled="isScaleDisabled"
                                    >
                                        {{ $t('zoomToScale') }}
                                    </b-button>
                                </div>
                                <!-- MinScale -->
                                <div class="form-group form-inline">
                                    <label
                                        for="minScale"
                                        class="col-form-label mr-2 scale-label"
                                    >
                                        {{ $t('webTheme.labelMinScale') }}
                                    </label>
                                    <x-number
                                        :id="'minScale'"
                                        :name="'minScale'"
                                        :minValue="50"
                                        :maxValue="1000000000"
                                        :required="false"
                                        :invalidMessage="minScaleErrorMessage"
                                        :state="validMinScale"
                                        v-model="webtheme.minScale"
                                        @input="$_validateMinScale"
                                        class="mr-2"
                                    >
                                    </x-number>
                                    <b-button
                                        variant="primary"
                                        size="sm"
                                        @click="$_onClickMinScale"
                                        :disabled="!this.webtheme.minScale"
                                    >
                                        {{ $t('zoomToScale') }}
                                    </b-button>
                                    <b-button
                                        variant="primary"
                                        size="sm"
                                        class="ml-2"
                                        @click="$_setMinScale"
                                        :disabled="!this.currentScale"
                                    >
                                        {{ $t('webTheme.labelButtonMinScale') }}
                                    </b-button>
                                </div>
                                <!-- MaxScale -->
                                <div class="form-group form-inline">
                                    <label
                                        for="maxScale"
                                        class="col-form-label mr-2 scale-label"
                                    >
                                        {{ $t('webTheme.labelMaxScale') }}
                                    </label>
                                    <x-number
                                        :id="'maxScale'"
                                        :name="'maxScale'"
                                        :minValue="50"
                                        :maxValue="1000000000"
                                        :required="false"
                                        v-model="webtheme.maxScale"
                                        @input="$_validateMaxScale"
                                        class="mr-2"
                                    >
                                    </x-number>
                                    <b-button
                                        variant="primary"
                                        size="sm"
                                        @click="$_onClickMaxScale"
                                        :disabled="!this.webtheme.maxScale"
                                    >
                                        {{ $t('zoomToScale') }}
                                    </b-button>
                                    <b-button
                                        variant="primary"
                                        size="sm"
                                        class="ml-2"
                                        @click="$_setMaxScale"
                                        :disabled="!this.currentScale"
                                    >
                                        {{ $t('webTheme.labelButtonMaxScale') }}
                                    </b-button>
                                </div>
                                <!-- Web preview buttons -->
                                <div class="btn-group nowrap">
                                    <b-button
                                        class="mr-2"
                                        size="sm"
                                        @click="
                                            $_resetPreviewSettings(
                                                $event,
                                                messageTypeConst.SetMapLocationDefault
                                            )
                                        "
                                    >
                                        {{ $t('labelMapPositionDefault') }}
                                    </b-button>
                                    <b-button
                                        class="mr-2"
                                        size="sm"
                                        @click="
                                            $_resetPreviewSettings(
                                                $event,
                                                messageTypeConst.SetMapLocationOrganizationBbox
                                            )
                                        "
                                    >
                                        {{ $t('labelMapPositionOrganization') }}
                                    </b-button>
                                    <b-button
                                        class="mr-2"
                                        size="sm"
                                        @click="$_updatePreviewSettings"
                                    >
                                        {{ $t('labelSetMapSection') }}
                                    </b-button>
                                    <b-button
                                        variant="primary"
                                        class="mr-2"
                                        size="sm"
                                        @click="$_updatePreview"
                                    >
                                        {{ $t('labelUpdate') }}
                                    </b-button>
                                </div>
                                <!-- Web preview IFrame -->
                                <div
                                    class="framecontainer"
                                    v-bind:style="mapStyle"
                                >
                                    <div
                                        class="preview-loading"
                                        v-bind:style="overlayStyle"
                                        v-show="running"
                                    >
                                        {{ $t('mapGenerationMessage') }}
                                    </div>
                                    <iframe
                                        title="webthemePreview"
                                        :style="mapStyle"
                                        class="previewframe"
                                        :src="url"
                                        ref="webIFrame"
                                    ></iframe>
                                </div>
                            </div>
                            <br />
                            <!-- WebTheme add / cancel buttons -->
                            <SubmitCancelRemove
                                :is-saving="isSaving"
                                :is-deleting="isDeleting"
                                :mode="mode"
                                @cancel="$_onCancel"
                                @remove="$_onRemove"
                                @copy="$_onCopy"
                                :isBtnSaveDisabled="isBtnSaveDisabled"
                                :showCopyButton="copyButtonShow"
                                :hideDeleteButton="copyMode"
                            >
                            </SubmitCancelRemove>
                        </template>
                    </div>
                </div>
            </div>
        </b-form>
        <add-bitmap-modal
            id="webthemeAddBitmapModal"
            :launchModal="launchModal"
            :selectedImageType="modalSelectedImageType"
            @modal-bitmap-saved="$_OnModalBitmapSaved"
        >
        </add-bitmap-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { orderBy, debounce } from 'lodash';
    import {
        getWebThemeUrl,
        getWebThemeShortUrl,
        convertToValueTextPair,
        availableFavicons,
        availableLogos,
        nprogress
    } from '../../services/utilities';
    import {
        AVAILABLE_LOGO_TYPE,
        CONTENT_TYPE_ID,
        MESSAGE_TYPE,
        MODE_ADD,
        MODE_EDIT,
        VUE_EDITOR_TYPES
    } from '../../constants';

    import XCheckbox from '../../components/BaseComponents/x-checkbox.vue';
    import xinput from '../../components/BaseComponents/x-input.vue';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import imageLoader from '../../components/ImageLoader.vue';
    import DualListBox from '../../components/DualListBox.vue';
    import InfoButton from '../../components/InfoButton.vue';
    import Tooltip from '../../components/Tooltip.vue';
    import SubmitCancelRemove from '../../components/SubmitCancelRemove.vue';
    import XSelect from '../../components/BaseComponents/x-select.vue';
    import XTextarea from '../../components/BaseComponents/x-textarea.vue';
    import XNumber from '../../components/BaseComponents/x-number.vue';
    import refcodeMixin from '../../components/Mixins/Refcodes/refcodeMixin.vue';
    import BaseSelect from '../../components/BaseComponents/base-select.vue';
    import AddBitmapModal from '../bitmaps/AddBitmapModal.vue';
    import { VueEditor } from 'vue2-editor';
    import ColorPicker from '../../components/ColorPicker.vue';
    import { mapGetters } from 'vuex';

    export default {
        mixins: [modalMixin, refcodeMixin],

        components: {
            'x-checkbox': XCheckbox,
            'x-input': xinput,
            'x-number': XNumber,
            'image-loader': imageLoader,
            DualListBox,
            SubmitCancelRemove,
            'info-button': InfoButton,
            tooltip: Tooltip,
            'x-select': XSelect,
            'x-textarea': XTextarea,
            BaseSelect,
            VueEditor,
            'add-bitmap-modal': AddBitmapModal,
            'color-picker': ColorPicker
        },

        props: {
            id: { type: Number, required: false, default: -1 },
            copyMode: { type: Boolean, required: false, default: false }
        },

        data() {
            return {
                // Constants
                availableLogoTypeConst: AVAILABLE_LOGO_TYPE,
                messageTypeConst: MESSAGE_TYPE,

                title: '',
                mode: 0,
                loading: false,
                errorInUse: null,
                imageTooLarge: false,
                showpart: false,
                running: false,
                isSaving: false,
                isDeleting: false,
                isPreview: false,
                themeState: null,
                feedbackState: null,
                webthemeId: 0,
                webtheme: { group: '' },
                webthemePortalGroups: [],
                webthemePortalThemeGroups: [],
                newTag: null,
                portalThemeGroup: null,
                tags: [],
                duplicateTags: [],
                themes: {},
                portalImageFile: null,
                mapLocation: null,
                fileReader: null,
                feedbackthemes: {},
                mapStyle: {},
                overlayStyle: {},
                url: '',
                loadImageErrorMessage: '',
                organizationId: this.$store.getters.userInfo.organizationId,
                hasPortalLicense:
                    this.$store.getters.userInfo.licenses.has_portal_license,
                organizationLanguage:
                    this.$store.getters.userInfo.organizationLanguage,
                selectedFeedbackTypeId: null,
                selectedMeasurementTypeId: null,
                selectedThemeId: null,
                selectedHighlightBorder: null,
                previewId: -1,
                themeType: 'web-theme',
                borderHighlightOptions: [],
                widthErrorMessage: '',
                heightErrorMessage: '',
                scaleErrorMessage: '',
                minScaleErrorMessage: null,
                widthErrorState: null,
                heightErrorState: null,
                scaleErrorState: null,
                nameErrorMessage: '',
                aliasErrorMessage: '',
                nameToeAlias: '',
                organizationBitmaps: [],
                launchModal: false,
                modalSelectedImageType: -1,
                currentScale: null,
                newScale: null,
                dbUseGuid: null,
                // https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/default-toolbar.js
                customToolbar: VUE_EDITOR_TYPES.WELCOME_PANEL
            };
        },

        created() {
            if (this.id && this.id > 0) {
                this.mode = MODE_EDIT;
                // By copy, we are creating new webtheme, so Id should be 0
                this.webthemeId = this.copyMode ? 0 : this.id;
                this.title = this.copyMode
                    ? this.$t('webThemeCardDetailCopyTitle')
                    : this.$t('webThemeCardDetailEditTitle');
            } else {
                this.mode = MODE_ADD;
                this.title = this.$t('webThemeCardDetailAddTitle');
            }
        },

        beforeDestroy() {
            // unsubscribe from onmessage event
            window.removeEventListener(
                'message',
                this.$_handleWindowMessages,
                false
            );
        },

        mounted() {
            this.$_getWebtheme();
            this.$_getWebthemePortalGroups();
            this.$_getWebthemePortalThemeGroups();
            this.$_getBorderHighlightOptions();
            this.$_getThemes();
            this.$_getFeedbackthemes();
            this.$_getOrganizationBitmaps();
            this.$_subscribeToWindowsMessages();
        },

        computed: {
            ...mapGetters(['getCheckForFeatureToggle']),
            validMinScale() {
                return this.minScaleErrorMessage === null;
            },
            computedAvailableBaseLayers() {
                if (
                    this.webtheme.baseLayers &&
                    this.webtheme.baseLayers.length > 0
                ) {
                    // Only available layers
                    return this.webtheme.baseLayers.filter((item) => {
                        return (
                            item.available === true &&
                            item.userEnabled === false &&
                            item.baselayer === true
                        );
                    });
                }
                return [];
            },

            computedFeedbackthemes() {
                if (this.feedbackthemes.length > 0) {
                    let result = this.feedbackthemes.filter(
                        (feedback) =>
                            feedback.contentTypeId === CONTENT_TYPE_ID.FEEDBACK
                    );
                    result = orderBy(result, [(item) => item.alias.toLowerCase()]);
                    return result.map((item) => {
                        return { value: item.id, text: item.alias };
                    });
                }
                return [];
            },

            computedMeasurements() {
                if (this.feedbackthemes.length > 0) {
                    let result = this.feedbackthemes.filter(
                        (feedback) =>
                            feedback.contentTypeId === CONTENT_TYPE_ID.MEASUREMENT
                    );
                    result = orderBy(result, [(item) => item.alias.toLowerCase()]);
                    return result.map((item) => {
                        return { value: item.id, text: item.alias };
                    });
                }
                return [];
            },

            computedSelectedBaseLayers() {
                if (
                    this.webtheme.baseLayers &&
                    this.webtheme.baseLayers.length > 0
                ) {
                    // Only available layers
                    return this.webtheme.baseLayers.filter((item) => {
                        return (
                            item.available === true &&
                            item.userEnabled === true &&
                            item.baselayer === true
                        );
                    });
                }
                return [];
            },

            computedBaseLayers() {
                return this.webtheme.baseLayers;
            },

            computedThemes() {
                if (this.themes.length > 0) {
                    let result = this.themes.slice(0);
                    result = orderBy(result, [(item) => item.name.toLowerCase()]);
                    return result.map((item) => {
                        return { value: item.id, text: item.name };
                    });
                }
                return [];
            },

            /**
             * Check if webtheme can be saved
             * @returns {boolean} indicating if webtheme can be saved
             */
            isBtnSaveDisabled() {
                return this.errorInUse || this.isSaving || this.isDeleting;
            },

            isScaleDisabled() {
                return this.newScale === null || this.scaleErrorState === false;
            },

            showPortalIcon() {
                // Show icon upload when user has portal license
                // and there is at least one portal tag entered.
                return this.hasPortalLicense && this.tags && this.tags.length > 0;
            },

            isWebTheme() {
                return this.themeType === 'web-theme';
            },

            inEditMode() {
                return this.mode === MODE_EDIT;
            },
            shortUrl() {
                return getWebThemeShortUrl(this.webtheme);
            },
            // * Check if item can be copied
            // This is true for an existing item and we are not in copymode
            copyButtonShow() {
                return this.id > 0 && !this.copyMode;
            },
            welcomeMessageTitle() {
                return this.webtheme.welcomeMessageTitle ?? 'Welkom';
            }
        },

        methods: {
            $_availableFavicons(bitmaps) {
                return availableFavicons(bitmaps);
            },

            onTagState(valid, invalid, duplicate) {
                this.duplicateTags = duplicate;
            },

            $_availableLogos(bitmaps) {
                return availableLogos(bitmaps);
            },

            $_gotoOverview() {
                this.$router.push('/dashboard/webthemes');
            },

            $_onCancel() {
                this.$_gotoOverview();
            },

            async $_continueSave() {
                this.$_sortBaselayers();

                // Searchbar
                this.webtheme.searchHeight = null;
                // searchHeightIdFrontend is a required field
                this.webtheme.searchHeightIdFrontend = 1;
                // portalgroups string from tags
                this.webtheme.portalGroup = this.tags.join();
                // portalThemeGroups
                this.webtheme.portalThemeGroup = this.portalThemeGroup;
                // Parameters
                if (this.mapLocation !== undefined && this.mapLocation !== null) {
                    this.webtheme.parameters.center = this.mapLocation.coordinates;
                    this.webtheme.parameters.zoom = parseFloat(
                        this.mapLocation.zoomLevel
                    );
                }
                // Icon
                this.webtheme.portalImage =
                    this.portalImageFile || this.webtheme.portalImage;
                this.$_updatePreviewStyle();

                this.webtheme.themeId = this.selectedThemeId;
                this.webtheme.feedbackTypeId = this.selectedFeedbackTypeId;
                this.webtheme.measurementTypeId = this.selectedMeasurementTypeId;
                this.webtheme.showTableView = this.isWebTheme
                    ? this.webtheme.showTableView
                    : false;
                this.webtheme.showTableViewSmallDevices =
                    this.isWebTheme && this.webtheme.showTableView
                        ? this.webtheme.showTableViewSmallDevices
                        : false;
                // Advanced Search Standard Open only if SearchField vailable and not Legenda Standard Open
                this.webtheme.openAdvancedSearchByStart =
                    this.isWebTheme && !this.webtheme.openLegenda
                        ? this.webtheme.openAdvancedSearchByStart
                        : false;

                this.webtheme.exportable = this.isWebTheme
                    ? this.webtheme.exportable
                    : false;

                this.isSaving = true;

                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'SaveWebTheme',
                        data: this.webtheme
                    });

                    if (this.inEditMode && !this.copyMode) {
                        this.$_preparePreview(result);
                    } else {
                        this.$router.push(
                            `/dashboard/webtheme/detail/${result.data.id}`
                        );
                    }
                    this.isSaving = false;
                    this.isPreview = false;
                } catch (error) {
                    // toaster show error
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        title: this.$t('saveFailureTitle'),
                        autoHideDelay: 10000
                    };
                    this.showToast(data);
                    this.isSaving = false;
                }
            },

            $_preparePreview(result) {
                this.webtheme.urlParameters = result.data.urlParameters;
                this.url = `${getWebThemeUrl(this.webtheme)}&previewid=${
                    this.previewId
                }`;
                if (!this.isPreview) {
                    const data = {
                        message: this.$t('webThemeCardSavedConfirmation'),
                        variant: 'success',
                        autoHideDelay: 2500,
                        noCloseButton: true
                    };
                    this.showToast(data);
                } else {
                    // Reload the Web IFrame with updated settings
                    this.$refs.webIFrame.contentWindow.location.reload();
                }
            },

            $_onCopy() {
                this.$router.push({
                    path: `/dashboard/webtheme/detail/copy/${this.id}`
                });
            },

            /**
             * Theme delete function
             */
            $_onRemove() {
                const confirmationMessage = {
                    message: this.$t('webThemeCardDeletionsConfirmation')
                };
                this.msgBoxConfirm(confirmationMessage).then(async (confirm) => {
                    if (confirm) {
                        this.isDeleting = true;
                        try {
                            await this.$store.dispatch('useApiData', {
                                name: 'DeleteWebTheme',
                                parameters: {
                                    id: this.webtheme.id
                                }
                            });
                            this.$_gotoOverview();
                            this.isDeleting = false;
                        } catch (error) {
                            const data = {
                                message: this.$t('deleteFailureMessage', [
                                    `${error.response.data.message}`
                                ]),
                                variant: 'danger',
                                title: this.$t('deleteFailureTitle'),
                                autoHideDelay: 10000
                            };
                            this.showToast(data);
                            this.isDeleting = false;
                        }
                    }
                });
            },
            $_onClickScale(event) {
                this.$_resetPreviewSettings(
                    event,
                    this.messageTypeConst.SetMapLocationScale,
                    this.newScale
                );
            },
            $_onClickMinScale(event) {
                this.$_resetPreviewSettings(
                    event,
                    this.messageTypeConst.SetMapLocationScale,
                    this.webtheme.minScale
                );
            },
            $_onClickMaxScale(event) {
                this.$_resetPreviewSettings(
                    event,
                    this.messageTypeConst.SetMapLocationScale,
                    this.webtheme.maxScale
                );
            },
            /**
             * Posts a message to Web IFrame containing either:
             * 1) Type: SetMapLocationDefault with coordinates & zoomLevel OR
             * 2) Type: SetMapLocationOrganizationBbox, without coordinates & zoomLevel
             * 3) Type: SetMapLocationScale, with scale
             * @param event
             * @param type - Constant value from MESSAGE_TYPE
             */
            $_resetPreviewSettings(event, type, scale) {
                // Prevent onSubmit
                event.preventDefault();
                // Create message and send it to Web IFrame
                const previewData = {
                    type,
                    coordinates:
                        type === MESSAGE_TYPE.SetMapLocationDefault
                            ? this.webtheme.parameters.center
                            : null,
                    zoomLevel:
                        type === MESSAGE_TYPE.SetMapLocationDefault
                            ? this.webtheme.parameters.zoom
                            : null,
                    scale: type === MESSAGE_TYPE.SetMapLocationScale ? scale : null
                };
                // Send message to Web application in the IFrame
                this.$refs.webIFrame.contentWindow.postMessage(
                    JSON.stringify(previewData),
                    window.location.origin
                );
            },

            $_exists: debounce(async function (searchTerm) {
                const webThemeParams = {
                    name: searchTerm,
                    webThemeId: this.webthemeId,
                    orgId: this.organizationId
                };
                const exists = await this.$store.dispatch('useApiData', {
                    name: 'WebThemeExists',
                    data: webThemeParams
                });
                this.$_validateName(exists, searchTerm);
                if (
                    !this.webtheme.alias ||
                    this.webtheme.alias.toLowerCase() ===
                        this.nameToeAlias.toLowerCase()
                ) {
                    this.webtheme.alias = searchTerm;
                }
                this.nameToeAlias = searchTerm;
            }, 500),

            /**
             * Retrieve border highlightOptions
             */
            $_getBorderHighlightOptions() {
                this.getRefCodes('BOOL_OR_SYSTEM').then((refCodes) => {
                    let result = refCodes.data.slice(0);
                    // Sort in descending order
                    result = orderBy(result, [(element) => element.code], ['desc']);
                    // Get the second element
                    const elm = result.splice(1, 1)[0];
                    // Add it as first member in array
                    result.unshift(elm);
                    this.borderHighlightOptions = result.map((item) => {
                        return { value: item.code, text: item.description };
                    });
                });
            },

            async $_getFeedbackthemes() {
                // get existing ows data from the backend
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetFeedbackTypeOverviewWeb'
                });
                if (result) {
                    this.feedbackthemes = result.data;
                }
            },

            $_getImage: function (event) {
                // Reference to the DOM input element
                const input = event.target;
                if (this.$_validateFile(input)) {
                    this.$_initFileReader();
                    this.fileReader.readAsDataURL(input.files[0]);
                }
                // Reset the value so that the same file can be selected again
                event.target.value = '';
            },

            $_getThemeLableText() {
                return this.themeType === 'web-theme'
                    ? this.$t('theme')
                    : `${this.$t('theme')}${this.$t('labelOptional')}`;
            },

            async $_getThemes() {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetThemeOverview'
                });
                this.themes = result?.data;
            },

            async $_getWebtheme() {
                this.loading = true;
                if (this.inEditMode) {
                    nprogress.start();
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetWebTheme',
                        parameters: {
                            id: this.$route.params.id
                        }
                    });
                    // Make object properties reactive for Vue
                    this.webtheme = Object.assign({}, result.data);
                    this.selectedHighlightBorder = this.webtheme.highlightBorder;
                    this.tags = this.webtheme.portalGroup
                        ? this.webtheme.portalGroup.split(',')
                        : [];
                    this.portalThemeGroup = this.webtheme.portalThemeGroup;
                    this.$_initSelectedWebthemeProperties();
                    this.loading = false;
                    this.showpart = true;
                    // If in copyMode, reset the ID and add "_copy" to the name and title
                    if (this.copyMode) {
                        this.webtheme.id = undefined;
                        this.webtheme.guid = undefined;
                        this.webtheme.name += this.$t('suffixUnderscoreCopy');
                        this.webtheme.alias += this.$t('suffixHyphenCopy');
                        // check if the new name already exists
                        this.$_exists(this.webtheme.name);
                    }
                    this.dbUseGuid = this.webtheme.useGuid;
                    nprogress.done();
                } else {
                    nprogress.start();
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetNewWebTheme'
                    });
                    // Make object properties reactive for Vue
                    this.webtheme = Object.assign({}, result.data);
                    this.$_initNewWebthemeProperties();
                    this.loading = false;
                    this.showpart = true;
                    nprogress.done();
                }
            },

            async $_getWebthemePortalGroups() {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetPortalGroups'
                });
                if (result?.data) {
                    this.webthemePortalGroups = convertToValueTextPair(result.data);
                }
            },

            async $_getWebthemePortalThemeGroups() {
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetPortalThemeGroups'
                });
                if (result?.data) {
                    this.webthemePortalThemeGroups = convertToValueTextPair(
                        result.data
                    );
                }
            },

            async $_getOrganizationBitmaps() {
                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetOrganizationLogos',
                        parameters: {
                            id: this.organizationId
                        }
                    });
                    if (result?.data) {
                        this.organizationBitmaps = Object.assign([], result.data);
                    }
                } catch (error) {
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        title: 'Ophalen van logos mislukt',
                        autoHideDelay: 10000
                    };
                    this.showToast(data);
                }
            },

            /**
             * Receives message on zoom/pan from WebTheme IFrame and stores it as mapLocation
             * @param event
             */
            $_handleWindowMessages(event) {
                // avoid parsing other kind of messages. We are just interested in coordinates from IFrame
                if (typeof event.data === 'string' && event.data.includes('type')) {
                    const message = JSON.parse(event.data);
                    // If message has coordinates and zoomLevel, accept it as new mapLocation
                    if (
                        message.type === MESSAGE_TYPE.UpdateMaplocation &&
                        message.coordinates !== undefined &&
                        message.zoomLevel !== undefined
                    ) {
                        this.mapLocation = Object.assign({}, message);
                    }
                    // Show current scale as readonly field
                    if (
                        message.type === MESSAGE_TYPE.GetCurrentScale &&
                        message.scale !== undefined
                    ) {
                        this.currentScale = Math.round(message.scale);
                    }
                }
            },

            $_initNewWebthemeProperties() {
                this.webtheme.parameters = {
                    width: 0,
                    height: 0
                };

                this.webtheme.urlParameters =
                    this.webtheme.urlParameters === null
                        ? ''
                        : this.webtheme.urlParameters;
                if (this.borderHighlightOptions.length > 0) {
                    const index = this.borderHighlightOptions.findIndex(function (
                        element
                    ) {
                        return element.value.toLowerCase() === 's';
                    });
                    if (index > -1) {
                        this.webtheme.highlightBorder =
                            this.borderHighlightOptions[index].value;
                    }
                }
                this.themeType = 'web-theme';
            },

            $_initFileReader() {
                this.fileReader = new FileReader();
                this.fileReader.onload = (e) => {
                    this.portalImageFile = e.target.result;
                };
            },

            $_initSelectedWebthemeProperties() {
                this.url = '';
                const random1 = Math.random().toString(36).substring(2);
                const random2 = Math.random().toString(36).substring(2);
                this.previewId = random1 + random2;

                if (this.webtheme.urlParameters === null) {
                    this.webtheme.urlParameters = '';
                }
                this.selectedThemeId = this.webtheme.themeId;
                this.selectedFeedbackTypeId = this.webtheme.feedbackTypeId;
                this.selectedMeasurementTypeId = this.webtheme.measurementTypeId;

                this.url = `${getWebThemeUrl(this.webtheme)}&previewid=${
                    this.previewId
                }`;
                // theme of feedback theme?
                if (
                    this.webtheme.feedbackTypeId &&
                    this.webtheme.feedbackTypeId > 0
                ) {
                    this.themeType = 'web-feedback-theme';
                } else {
                    this.themeType = 'web-theme';
                }
                this.$_updatePreviewStyle();
            },

            $_openAddBitmapModal(imageType) {
                this.launchModal = !this.launchModal;
                this.modalSelectedImageType = imageType;
            },

            /**
             * Radio button 'enable-web-theme' click event
             * @param  {*} e, click event object
             */
            $_onClickEnableWebTheme() {
                this.selectedFeedbackTypeId = null;
            },

            $_onSelectFeedbackTypeId(input) {
                this.selectedFeedbackTypeId = input;
            },

            $_onSelectMeasurementTypeId(input) {
                this.selectedMeasurementTypeId = input;
            },

            $_onSelectHighlightBorder(input, webtheme) {
                webtheme.highlightBorder = input;
            },

            $_onLogoSelected(input) {
                this.webtheme.logoId = input;
            },

            $_onFaviconSelected(input) {
                this.webtheme.faviconId = input;
            },

            $_OnModalBitmapSaved(savedBitmap) {
                if (savedBitmap) {
                    // Add newly created bitmap to the set
                    this.organizationBitmaps.push(savedBitmap);
                    // Assign newly created bitmap to the organization logo or favicon
                    if (savedBitmap.imageType === AVAILABLE_LOGO_TYPE[0].value) {
                        this.webtheme.logoId = savedBitmap.id;
                    } else if (
                        savedBitmap.imageType === AVAILABLE_LOGO_TYPE[1].value
                    ) {
                        this.webtheme.faviconId = savedBitmap.id;
                    }
                }
            },

            $_onSelectThemeId(input) {
                this.selectedThemeId = input;
            },

            $_onSubmit() {
                if (
                    this.$refs.webthemeform.checkValidity() &&
                    this.heightErrorState === null &&
                    this.widthErrorState === null &&
                    this.minScaleErrorMessage === null
                ) {
                    this.$_save();
                }
            },

            $_removeImage() {
                if (this.webtheme.portalImage) {
                    this.webtheme.portalImage = null;
                }
                if (this.portalImageFile) {
                    this.portalImageFile = null;
                }
            },

            async $_save() {
                if (this.selectedThemeId && this.selectedThemeId > 0) {
                    // Check for secured themelayers
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'ContainsSecuredLayers',
                        parameters: {
                            id: this.selectedThemeId
                        }
                    });
                    if (result?.data) {
                        this.msgBoxConfirm({
                            okTitle: this.$t('btnSaveLabel'),
                            message: this.$t('themeCardSecuredInfo')
                        }).then((confirm) => {
                            if (confirm) {
                                this.$_continueSave();
                            }
                        });
                    } else {
                        this.$_continueSave();
                    }
                } else {
                    this.$_continueSave();
                }
            },

            $_sortBaselayers() {
                const enabledList = [];
                const disabledList = [];

                if (
                    this.webtheme.baseLayers &&
                    this.webtheme.baseLayers.length > 1
                ) {
                    for (let baseLayer of this.webtheme.baseLayers) {
                        if (baseLayer.userEnabled) {
                            enabledList.push(baseLayer);
                        } else {
                            disabledList.push(baseLayer);
                        }
                    }
                    this.webtheme.baseLayers = enabledList.concat(disabledList);

                    for (let j = 0; j < this.webtheme.baseLayers.length; j++) {
                        this.webtheme.baseLayers[j].order = j;
                    }
                }
            },

            savePortalGroupSelection(newTag) {
                this.tags.push(newTag);
                this.newTag = null;
            },

            savePortalThemeGroupSelection(portalThemeGroup) {
                this.portalThemeGroup = portalThemeGroup;
            },
            /**
             * Receive message from Webtheme IFrame, containing the changed coordinates and zoomLevel from the map
             * @param {type} e - message with the new coordinates and zoomlevel
             */
            $_subscribeToWindowsMessages() {
                // subscribe to onmessage event of windows
                window.addEventListener(
                    'message',
                    this.$_handleWindowMessages,
                    false
                );
            },

            $_updatePreview() {
                if (this.inEditMode) {
                    this.isPreview = true;
                    this.$_save();
                }
            },

            $_updatePreviewSettings() {
                this.isPreview = true;
                this.$_updatePreview();
            },

            $_updatePreviewStyle() {
                if (
                    this.webtheme.parameters &&
                    (this.webtheme.parameters.width !== 0 ||
                        this.webtheme.parameters.height !== 0)
                ) {
                    this.mapStyle = {
                        position: 'inherit',
                        transform: 'scale(1)'
                    };

                    this.overlayStyle = {
                        margin: 0,
                        'margin-top': '5px'
                    };

                    if (this.webtheme.parameters.width !== 0) {
                        this.mapStyle.width = `${this.webtheme.parameters.width}px`;
                        this.overlayStyle.width = `${this.webtheme.parameters.width}px`;
                    }

                    if (this.webtheme.parameters.height !== 0) {
                        this.mapStyle.height = `${this.webtheme.parameters.height}px`;
                        this.overlayStyle.height = `${this.webtheme.parameters.height}px`;
                    }
                } else {
                    this.overlayStyle = {};
                    this.mapStyle = {};
                }
            },
            $_updateComputedBaseLayers(newVal) {
                this.webtheme.baseLayers = newVal;
            },
            $_welcomeMessageEnabled() {
                return false;
            },
            /**
             * Validate image on size
             * @param {Object} image - The image to be validated, properties to validate on: image.filename, image.filetype & image.filesize
             * @returns {bool} returns boolean value indicating if the image is valid.
             */
            $_validateFile(input) {
                let valid = true;
                if (!input.files) {
                    valid = false;
                    this.loadImageErrorMessage = this.$t(
                        'loadFileErrNoFileIsChosen'
                    );
                } else if (!input.files[0]) {
                    valid = false;
                    this.loadImageErrorMessage = this.$t(
                        'loadFileErrFileNoContent'
                    );
                } else if (input.files[0].size > 1024 * 1024) {
                    valid = false;
                    this.loadImageErrorMessage = this.$t('loadFileErrFileTooLarge');
                    this.imageTooLarge = true;
                } else {
                    this.imageTooLarge = false;
                }

                return valid;
            },

            $_validateScale(input) {
                if (input < 50 || input > 1000000000) {
                    this.scaleErrorMessage = this.$t('invalidRangeValue', [
                        '50',
                        '1000000000'
                    ]);
                    this.scaleErrorState = false;
                } else {
                    this.scaleErrorMessage = '';
                    this.scaleErrorState = null;
                }
            },

            $_validateWidth(input) {
                if ((input !== 0 && input < 200) || input > 2000) {
                    this.widthErrorMessage = this.$t(
                        'feedbackWidthHeightErrorMessage'
                    );
                    this.widthErrorState = false;
                } else {
                    this.widthErrorMessage = '';
                    this.widthErrorState = null;
                }
            },

            $_validateHeight(input) {
                if ((input !== 0 && input < 200) || input > 2000) {
                    this.heightErrorMessage = this.$t(
                        'feedbackWidthHeightErrorMessage'
                    );
                    this.heightErrorState = false;
                } else {
                    this.heightErrorMessage = '';
                    this.heightErrorState = null;
                }
            },

            $_validateName(exists, name) {
                if (exists.data) {
                    this.errorInUse = exists.data;
                    this.nameErrorMessage = this.$t('errorNameWebthemeExists');
                } else if (name.length < 3) {
                    this.nameErrorMessage = this.$t('minLengthErrorMessage', [
                        'naam'
                    ]);
                    this.errorInUse = true;
                } else {
                    this.nameErrorMessage = '';
                    this.errorInUse = false;
                }
            },

            $_validateAlias() {
                if (
                    this.webtheme.alias !== null &&
                    this.webtheme.alias !== undefined
                ) {
                    if (
                        this.webtheme.alias.length > 0 &&
                        this.webtheme.alias.length < 3
                    ) {
                        this.aliasErrorMessage = this.$t('minLengthErrorMessage', [
                            'alias'
                        ]);
                    } else {
                        this.aliasErrorMessage = '';
                    }
                }

                return this.aliasErrorMessage.length === 0;
            },

            /**
             * Update webtheme exportable boolean, exportable is false when showTableView is false
             * @param {object} webtheme - webtheme object
             */
            $_onInputTableView(webtheme) {
                if (webtheme.showTableView === false) {
                    webtheme.exportable = false;
                    webtheme.showTableViewSmallDevices = false;
                }
            },
            $_onInputShowSearchField(webtheme) {
                if (webtheme.showSearch === false) {
                    webtheme.openAdvancedSearchByStart = false;
                }
            },
            $_textWelcomeMessageTitle(newVal) {
                this.webtheme.welcomeMessageTitle = newVal;
            },
            $_setMinScale() {
                this.webtheme.minScale = this.currentScale;
            },
            $_setMaxScale() {
                this.webtheme.maxScale = this.currentScale;
            },
            $_validateMinScale(input) {
                this.webtheme.minScale = input;
                this.minScaleErrorMessage = null;
                if (
                    this.webtheme.minScale &&
                    this.webtheme.maxScale &&
                    this.webtheme.minScale > this.webtheme.maxScale
                ) {
                    this.minScaleErrorMessage = this.$t('webTheme.minScaleError');
                }
            },
            $_validateMaxScale(input) {
                this.webtheme.maxScale = input;
                this.minScaleErrorMessage = null;
                if (
                    this.webtheme.minScale &&
                    this.webtheme.maxScale &&
                    this.webtheme.minScale > this.webtheme.maxScale
                ) {
                    this.minScaleErrorMessage = this.$t('webTheme.minScaleError');
                }
            }
        },
        watch: {
            // When the themeID changes
            async selectedThemeId(newValue) {
                // Get theme details so we have the theme layers available
                // Mark baselayers that are being used in the theme as not available.
                // Mark already used baselayer as not being used.
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetThemeDetail',
                    parameters: {
                        id: newValue
                    }
                });
                const theme = Object.assign({}, result.data);
                const layers = theme.themeLayers.map((tl) => tl.id);
                this.webtheme.baseLayers.forEach((baselayer) => {
                    if (layers.includes(baselayer.id)) {
                        // baselayer komt voor als laag in thema zet op unavailable en userEnabled op false
                        //Make object properties reactive for Vue
                        Vue.set(baselayer, 'available', false);
                        Vue.set(baselayer, 'userEnabled', false);
                    } else {
                        Vue.set(baselayer, 'available', true);
                    }
                });
            }
        }
    };
</script>

<style scoped>
.floated {
    display: inline-block;
    float: right;
    margin-right: 8%;
    width: 10%;
}

.row-divier {
    height: 6px;
}

.previewframe {
    width: 100%;
    height: 100%;
    border: 0;
}

.framecontainer {
    width: 1000px;
    display: block;
    height: 500px;
    margin-top: 10px;
    outline: 1px inset #fafafa;
}

.preview-loading {
    width: 1000px;
    height: 500px;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.8);
    position: absolute;
    float: left;
    z-index: 9;
    border: solid #333 1px;
    padding-top: 25%;
    font-size: 18pt;
    color: #333;
}

.nowrap button {
    white-space: nowrap;
}

.inline {
    display: inline;
}

.scale {
    min-width: 50px;
}
.warning {
    font-size: 0.875em;
    color: #dc3545;
}
.no-welcome-panel {
    display: none;
}
.scale-label {
    width: 130px;
}
</style>
